"use strict";

var _classCallCheck = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddressDataType = void 0;

var ethereum_types_1 = require("ethereum-types");

var ethUtil = require("ethereumjs-util");

var _ = require("lodash");

var blob_1 = require("../abstract_data_types/types/blob");

var constants_1 = require("../utils/constants");

var AddressDataType = /*#__PURE__*/function (_blob_1$AbstractBlobD) {
  _inherits(AddressDataType, _blob_1$AbstractBlobD);

  var _super = _createSuper(AddressDataType);

  function AddressDataType(dataItem, dataTypeFactory) {
    var _this;

    _classCallCheck(this, AddressDataType);

    _this = _super.call(this, dataItem, dataTypeFactory, AddressDataType._SIZE_KNOWN_AT_COMPILE_TIME);

    if (!AddressDataType.matchType(dataItem.type)) {
      throw new Error("Tried to instantiate Address with bad input: ".concat(dataItem));
    }

    return _this;
  }

  _createClass(AddressDataType, [{
    key: "encodeValue",
    // Disable prefer-function-over-method for inherited abstract methods.

    /* tslint:disable prefer-function-over-method */
    value: function encodeValue(value) {
      if (!ethUtil.isValidAddress(value)) {
        throw new Error("Invalid address: '".concat(value, "'"));
      }

      var valueBuf = ethUtil.toBuffer(value);
      var encodedValueBuf = ethUtil.setLengthLeft(valueBuf, constants_1.constants.EVM_WORD_WIDTH_IN_BYTES);
      return encodedValueBuf;
    }
  }, {
    key: "decodeValue",
    value: function decodeValue(calldata) {
      var valueBufPadded = calldata.popWord();
      var valueBuf = valueBufPadded.slice(AddressDataType._DECODED_ADDRESS_OFFSET_IN_BYTES);
      var value = ethUtil.bufferToHex(valueBuf);

      var valueLowercase = _.toLower(value);

      return valueLowercase;
    }
  }, {
    key: "getDefaultValue",
    value: function getDefaultValue() {
      return AddressDataType._DEFAULT_VALUE;
    }
  }, {
    key: "getSignatureType",
    value: function getSignatureType() {
      return ethereum_types_1.SolidityTypes.Address;
    }
  }], [{
    key: "matchType",
    value: function matchType(type) {
      return type === ethereum_types_1.SolidityTypes.Address;
    }
  }]);

  return AddressDataType;
}(blob_1.AbstractBlobDataType);

exports.AddressDataType = AddressDataType;
AddressDataType._SIZE_KNOWN_AT_COMPILE_TIME = true;
AddressDataType._ADDRESS_SIZE_IN_BYTES = 20;
AddressDataType._DECODED_ADDRESS_OFFSET_IN_BYTES = constants_1.constants.EVM_WORD_WIDTH_IN_BYTES - AddressDataType._ADDRESS_SIZE_IN_BYTES;
AddressDataType._DEFAULT_VALUE = '0x0000000000000000000000000000000000000000';